import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import LoadingSpinner from "../LoadingSpinner";

/**
 * Route guard for /internal/* pages.
 *
 * Access is granted only if the authenticated Cognito user belongs to the
 * "internal-axle" group. Membership is managed in the Cognito User Pool console.
 *
 * Unauthorized users are redirected to /ignition.
 */
const InternalGuard = () => {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const groups =
          (user?.signInUserSession?.accessToken?.payload?.[
            "cognito:groups"
          ] as string[] | undefined) ?? [];

        setAllowed(groups.includes("internal-axle"));
      } catch {
        setAllowed(false);
      } finally {
        setChecking(false);
      }
    };

    void checkAccess();
  }, []);

  if (checking) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/ignition" replace />;
  }

  return <Outlet />;
};

export default InternalGuard;
